module.exports = __webpack_public_path__ + "assets/profileIcon-54bd8f.svg";